<template>
  <div class="card">
    <div
      class="main-card-body"
      v-if="mData.dataDefault.listFeature.includes('FT1401')"
    >
      <!-- <Banner /> -->
      <div class="body-header d-flex al-center">
        <div class="d-flex al-center">
          <div class="r">
            <h4 v-if="viewType == 'Month' || viewType == 'Day'">
              Kỳ tháng {{ mData.month }}
            </h4>
          </div>
          <div class="d-flex1 div_btn ml-4">
            <div
              id="Day"
              class="fake_btn active"
              @click="changeTypeView('Day')"
            >
              <span>Ngày</span>
            </div>
            <div
              id="Month"
              class="fake_btn ml-2"
              @click="changeTypeView('Month')"
            >
              <span>Tháng</span>
            </div>
          </div>
          <div
            class="select-shift ml-3"
          >
            <el-select
              class="shift__input"
              v-model="mData.shiftId"
              placeholder="Chọn ca"
              @change="changeShift"
            >
              <el-option
                v-for="(item,index) in mData.dataDefault.listShift"
                :key="index"
                :label="item.code"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="text-right">
          <p>
            Update gần nhất:
            <span
              :class="
                mData.timeGetData == 'Chưa có dữ liệu chấm công!' ? 'time-update c-orange' :
                (new Date().getTime() - new Date(mData.timeGetData).getTime()) / 60000 <= 15 ? 'time-update c-green' :
                15 < (new Date().getTime() - new Date(mData.timeGetData).getTime()) / 60000 &&
                (new Date().getTime() - new Date(mData.timeGetData).getTime()) / 60000 <= 30 ? 'time-update c-orange' :
                'time-update c-red'
              "
            >
              {{ mData.timeGetData == "Chưa có dữ liệu chấm công!" ? mData.timeGetData :formatDateTime(mData.timeGetData) }}
            </span>
          </p>
        </div>
      </div>
      <div class="main-body mt-3">
        <b-row class="panel-group">
          <b-col class="col-12 col-lg-4 col-md-4 col-sm-6">
            <div class="card card-panel" @click="fn_go('EmployeeList')">
              <p class="title-box_card">Tổng số<br> nhân viên</p>
              <div class="underline bgc-green"></div>
              <p class="count c-green">
                <countTo
                  :startVal="mData.countConfig.startVal"
                  :endVal="mData.totalEmployee"
                  :duration="mData.countConfig.timeDuration"
                ></countTo>
              </p>
              <!-- <div class="box__status" v-if="viewType == 'Month'">
                <p class="box__status-text c-green">
                  <i class="el-icon-top box__status-icon"></i>
                    <countTo
                    :startVal="0"
                    :endVal="2"
                    :duration="mData.countConfig.timeDuration"
                  ></countTo>
                </p>
                <p class="box__status-text c-red">
                  <i class="el-icon-bottom box__status-icon"></i>
                  <countTo
                    :startVal="0"
                    :endVal="3"
                    :duration="mData.countConfig.timeDuration"
                  ></countTo>
                </p>
              </div> -->
            </div>
          </b-col>
          <b-col class="col-12 col-lg-4 col-md-4 col-sm-6">
            <div
              class="card card-panel"
              @click="fn_go('EmployeeRequestNeedApprove')"
            >
              <p class="title-box_card">Yêu cầu<br> phê duyệt</p>
              <div class="underline bgc-light-blue"></div>
              <p class="count c-light-blue">
                <countTo
                  :startVal="mData.countConfig.startVal"
                  :endVal="mData.totalRequestNeedApprove"
                  :duration="mData.countConfig.timeDuration"
                ></countTo>
              </p>
            </div>
          </b-col>
          <b-col class="col-lg-4">

          </b-col>
        </b-row>
        <div v-if="viewType == 'Day'" class="mt-4 div-chart">
          <DayDashboard
            v-if="show"
            :viewType="viewType"
            :totalEmployee="mData.totalEmployee"
            :shiftId="mData.shiftId"
            :employeeShift="mData.dataDefault.listEmployeeShift"
            :shiftInfo="mData.shiftInfo"
            :listEmployee="mData.dataDefault.listEmployee"
            @done="emitEventComponent"
          />
        </div>
        <div v-if="viewType == 'Month'" class="mt-4 div-chart">
          <MonthDasboard
            v-if="show"
            :viewType="viewType"
            :shiftId="mData.shiftId"
            :employeeShift="mData.dataDefault.listEmployeeShift"
            :shiftInfo="mData.shiftInfo"
            :listEmployee="mData.dataDefault.listEmployee"
            :listRequest="mData.dataDefault.listRequestMonth"
            @done="emitEventComponent"
          ></MonthDasboard>
        </div>
      </div>
    </div>
    <Loading v-if="loading"/>
  </div>
</template>

<script>
import countTo from "vue-count-to";
import MethodService from "../../../service/MethodService";
import EmployeeApi from "../../../moduleApi/EmployeeApi";
import EmployeeRequestApi from "../../../moduleApi/EmployeeRequestApi";
import TimeKeepingRawCurrentLogApi from '../../../moduleApi/TimeKeepingRawCurrentLogApi';
import ShiftApi from '../../../moduleApi/ShiftApi';
import DoughnutChart from "@/component/Chart/DoughnutChart";
import MonthDasboard from "./MonthDasboard";
import DayDashboard from "./DayDashboard";
import EmployeeShiftApi from '../../../moduleApi/EmployeeShiftApi';
import Banner from "./Banner.vue";
import * as moment from "moment";
import _ from "lodash";
import { Filter } from "mushroomjs"
import Loading from "../../../component/Loading"
import toastr from "toastr";
import EventBus from '@/service/EventBus';

export default {
  components: {
    countTo,
    DoughnutChart,
    MonthDasboard,
    DayDashboard,
    Banner,
    Loading,
  },
  data() {
    return {
      show: true,
      activeNames: ["1", "2"],
      viewType: "Day",
      date: new Date(),
      firstDayInMonth: new Date(MethodService.getFirstDayOfMonth(new Date())).toISOString(),
      lastDayInMonth:  new Date(MethodService.getLastDayOfMonth(new Date())).toISOString(),
      loading: true,
      mData: {
        shiftId: "",
        timeGetData: "",
        dayMonthYear: "",
        month: 8,
        year: 2022,
        date: "",
        countConfig: {
          startVal: 0,
          endVal: 33,
          timeDuration: 1500
        },
        totalEmployee: 0,
        totalRequestNeedApprove: 0,
        shiftInfo: {},
        dataDefault: {
          listFeature: MethodService.getListFeatures(),
          currentUser: MethodService.getCurrentUser(),
          companyInfo: {},
          listEmployee: [],
          listEmployeeShift: [],
          listEmployeeRequest: [],
          listShift: [],
          listRequestMonth: []
        },
      }
    };
  },
  methods: {
    emitEventComponent() {
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    async fn_initData() {
      if (this.mData.dataDefault.currentUser.roles.includes("AdminSystem")) {
        toastr.warning('Bạn không có quyền truy cập trang này!')
        this.$router.push({
          name: 'Admin-Hello'
        }).catch(() => {})
        return
      }
      this.loading = true
      mushroom["time_keeping_raw_current"].invalidCache();

      let dataRunTime = {
        limit: 1,
        sort: "-created_at"
      };

      try {
        const shiftApiReq = ShiftApi.list({
          filters: "applied_end_time>=" + moment(new Date()).format("yyyy-MM-DD"),
          limit: 999999,
        });
        const runTimeReq = TimeKeepingRawCurrentLogApi.list(dataRunTime);

        const runTimeRes = await runTimeReq;
        const shiftApiRes = await shiftApiReq;

        this.mData.dataDefault.listShift = shiftApiRes.result;
        if (this.mData.dataDefault.listShift.length > 0) {
          this.mData.shiftId = this.mData.dataDefault.listShift[0].id;
          this.mData.shiftInfo =  this.mData.dataDefault.listShift[0];
        }
        if (
          runTimeRes &&
          runTimeRes.result.length > 0 &&
          runTimeRes.result[0].created_at
        ) {
          this.mData.timeGetData = runTimeRes.result[0].created_at;
        } else {
          this.mData.timeGetData = "Chưa có dữ liệu chấm công!";
        }
        // setTimeout(async () => {
          await this.fn_getEmployeeFromShift(this.mData.shiftId);
          await this.fn_getTotalRequestFromShift(this.mData.shiftId);
        // }, 100);

      } catch (error) {
        console.log("error",error);
      }
    },
    async changeShift(){
      // this.show = false;
      this.loading = true
      await this.fn_getEmployeeFromShift(this.mData.shiftId);
      await this.fn_getTotalRequestFromShift(this.mData.shiftId);
      this.mData.shiftInfo = this.mData.dataDefault.listShift.find(e => {
        return e.id == this.mData.shiftId
      })
      setTimeout(() => {
        // this.show = true;
        this.loading = false
      }, 500);

    },
    async fn_getTotalRequestFromShift(shiftId){
      try {
        var date = new Date();
        var firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
        var lastDayOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0,23,59,59);
        let dataFilterEmployeeRequestTotal = {
          cid: this.mData.dataDefault.companyInfo.id,
          sid: shiftId,
          sd: firstDayOfMonth,
          ed: lastDayOfMonth
        };
        const employeeRequestTotalApiRes = await EmployeeRequestApi.getListEmployeeRequest(
          dataFilterEmployeeRequestTotal
        );
        let requestWFA = employeeRequestTotalApiRes.result.filter(e => {
         return e.status == "WAITING_FOR_APPROVAL"
        })
        this.mData.dataDefault.listRequestMonth = employeeRequestTotalApiRes.result;
        let checkequest = _.intersectionBy(requestWFA, this.mData.dataDefault.listEmployee, 'employee_no');
        if (checkequest.length == 0) {
          this.mData.totalRequestNeedApprove = 0;
        } else {
          this.mData.totalRequestNeedApprove = requestWFA.length;
        }
      } catch (error) {
        console.log("error",error)
      }
    },
    async fn_getEmployeeFromShift(shiftId){
      // this.mData.dataDefault.listEmployee = []
      let filter = Filter.and(
        Filter.eq('shift_id', shiftId),
        Filter.or(
          Filter.and(
            Filter.lte('start_time', this.firstDayInMonth),
            Filter.isNull('end_time')
          ),
          Filter.and(
            Filter.lte('start_time', this.firstDayInMonth),
            Filter.gte('end_time', this.lastDayInMonth)
          ),
          Filter.and(
            Filter.gte('start_time', this.firstDayInMonth),
            Filter.isNull('end_time')
          ),
          Filter.and(
            Filter.lte('start_time', MethodService.getCurrentDate()),
            Filter.isNull('end_time')
          ),
          Filter.and(
            Filter.lte('start_time', MethodService.getCurrentDate()),
            Filter.gte('end_time', MethodService.getCurrentDate())
          )
        )
      ).build()
      let dataFilterEmployeeShift = {
          limit: 1000,
          filters: filter,
          sort: "employee_id"
        };
        const employeeShiftApiRes = await EmployeeShiftApi.list(
          dataFilterEmployeeShift
        );
        let arrEmployeeInShift = _.uniqBy(
          employeeShiftApiRes.result,
          x => [x.employee_id].join()
        );
        this.mData.dataDefault.listEmployeeShift = arrEmployeeInShift;
        let employeeIds = [];
        employeeIds = MethodService.findListItemDifferent(
          arrEmployeeInShift,
          "employee_id"
        );
        const employeeApiRes = await EmployeeApi.list({
          filters: "id:in:"+employeeIds.join(","),
          limit: employeeIds.length
        })
        this.mData.dataDefault.listEmployee = employeeApiRes.result.filter(e => {
          return e.status == "DANG_LAM_VIEC"
        })
        this.mData.totalEmployee = this.mData.dataDefault.listEmployee.length;
    },
    fn_go(type) {
      if (type == "EmployeeList") {
        this.$router.push({
          name: "Admin-EmployeeManager-list",
          query: {from: "Dashboard"}
        });
      } else if (type == "EmployeeRequestNeedApprove") {
        this.$router.push({
          name: "Admin-ManageRequests-RequestsWaitingForApproval",
          query: {tab: "NEED_APPROVAL"}
        });
      } else if (type == "WorkRequest") {
        this.$router.push({
          name: "Admin-ManageRequests-ListRequests-WorkAdditionRequests"
        });
      } else if (type == "DayOffRequest") {
        this.$router.push({
          name: "Admin-ManageRequests-ListRequests-DayOffRequests"
        });
      } else if (type == "WorkSheet") {
        this.$router.push({
          name: "Admin-Timekeeping-Worksheet"
        });
      } else if (type == "OnlineRequest") {
        this.$router.push({
          name: "Admin-ManageRequests-ListRequests-TimeKeepingOnlineRequests"
        });
      }
    },
    changeTypeView(type) {
      if (type == "Day") {
        this.viewType = "Day";
        document.getElementById("Month").classList.remove("active");
        document.getElementById("Day").classList.add("active");
      } else {
        this.viewType = "Month";
        document.getElementById("Day").classList.remove("active");
        document.getElementById("Month").classList.add("active");
      }
      let eventName = `changeTypeView${type}`
      console.log('eventName', eventName)
      EventBus.$emit('changeTypeView')
    },
    formatDate(value) {
      return MethodService.formatDate(value, "date");
    },
    formatDateTime(value) {
      return MethodService.formatDate(value, "timedate");
    },
    refreshData(){
      this.fn_initData();
      window.setTimeoutX = setTimeout(() => {
        this.refreshData();
      }, 1000 * 300); //5 phút
    }
  },
  created() {
    this.mData.totalRequestNeedApprove = 0;
    this.mData.dataDefault.companyInfo = MethodService.getCompanyInfo();
    this.mData.month =
      new Date().getMonth() + 1 < 10
        ? "0" + (new Date().getMonth() + 1)
        : new Date().getMonth() + 1;
    this.mData.year = new Date().getFullYear();
    this.mData.dayMonthYear = this.formatDate(new Date());
    this.mData.date =
      new Date().getDay() == 0
        ? "Chủ nhật"
        : new Date().getDay() == 1
        ? "Thứ 2"
        : new Date().getDay() == 2
        ? "Thứ 3"
        : new Date().getDay() == 3
        ? "Thứ 4"
        : new Date().getDay() == 4
        ? "Thứ 5"
        : new Date().getDay() == 5
        ? "Thứ 6"
        : new Date().getDay() == 6
        ? "Thứ 7"
        : "";
    this.refreshData();
    // setTimeout(() => {
    //   this.show = true;
    // }, 100);
  },
  mounted() {
    if (this.mData.dataDefault.currentUser.roles.includes("AdminSystem"))
      toastr.warning('Bạn không có quyền truy cập trang này!')
  },
};
</script>

<style scoped>
.select-shift{
  max-width: 150px;
}
::v-deep .shift__input .el-input__inner{
  border-radius: 20px !important;
}
.row {
  margin-left: -15px;
  margin-right: -15px;
}
.word-break-btn {
  width: 100%;
  height: 50px;
  text-transform: none;
  font-size: 13px;
  white-space: normal;
  padding: 5px 5px;
}
.al-center {
  align-items: center;
}
.time-update {
  font-size: 15px;
  font-weight: 700;
}
.div_btn {
  padding: 10px;
  width: 200px;
  height: 45px;
  background: var(--white);
  box-shadow: 0px 0px 20px rgba(43, 43, 43, 0.131);
  border-radius: 25px;
}
.d-flex1 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.fake_btn {
  width: 100%;
  padding: 5px;
  text-align: center;
  background: #fdfdfd;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.049);
  border-radius: 25px;
}
.fake_btn.active {
  background-color: var(--orange);
  color: #fff;
  letter-spacing: 0.01em;
  font-weight: 500;
  font-size: 12px;
  /* line-height: 14px; */
}
.fake_btn:hover {
  cursor: pointer;
}
.fake_btn span {
  font-size: 15px;
  font-weight: 400;
}
.panel-group .card-panel {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  border-radius: 15px;
  height: 110px;
  cursor: pointer;
  font-size: 15px;
  position: relative;
  overflow: hidden;
  color: #666;
  background: #fff;
  box-shadow: rgba(0, 0, 0, 0.1) -4px 9px 25px -6px;
  border-color: #c0c4cc;
}
.title-box_card {
  /* margin-bottom: 10px;
  font-size: 15px;
  font-weight: 600;
  line-height: 32px;
  position: absolute;
  top: 10px;
  left: 20px; */
  position: absolute;
  top: 20px;
  left: 20px;
  color: #444242;
  margin-bottom: 10px;
  font-size: 18px;
  font-weight: 700;
  line-height: 23px;
}
.underline {
  height: 5px;
  width: 85px;
  border-radius: 100px;
  position: absolute;
  top: 85px;
  left: 20px;
}
.icon {
  position: absolute;
  top: 30%;
  right: 10px;
}
.icon i {
  font-size: 35px;
}
.count {
  margin-right: 100px;
  /* font-size: 45px;
  font-weight: bold;
  word-spacing: -5px;
  letter-spacing: -1px; */
}
.box__status {
  display: block;
  position: absolute;
  right: 20px;
}
.box__status .box__status-text {
  font-size: 26px;
  font-weight: bold;
}
.box__status .box__status-icon {
  font-size: 35px;
  font-weight: bold;
}
.bgc-green {
  background-color: #30da88;
}
.bgc-light-blue {
  background-color: var(--blue);
}
.bgc-orange {
  background-color: #f79d61;
}
.bgc-red {
  background-color: var(--red);
}
.c-green {
  color: #30da88;
}
.c-light-blue {
  color: var(--blue);
}
.c-orange {
  color: #f79d61;
}
.c-red {
  color: var(--red);
}
.c-white {
  color: #fff;
}
.box-shadow {
  box-shadow: rgba(0, 0, 0, 0.1) -4px 9px 25px -6px;
}
.card.box-card {
  padding: 15px;
  border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0.1) -4px 9px 25px -6px;
  border-color: #c0c4cc;
}
::v-deep .el-collapse {
  border-top-color: transparent;
  border-top-width: 0;
  border-bottom-color: transparent;
  border-bottom-width: 0;
}
::v-deep .el-collapse .el-collapse-item__header {
  background-color: var(--white);
  border: 1px solid #c8ced3;
}
::v-deep .el-collapse .el-collapse-item__content {
  border: 1px solid #c8ced3;
  border-top-width: 0;
}
@media (min-width: 1600px) {
  .title-box_card {
    font-size: 20px;
  }
  .subtitle {
    font-size: 20px;
  }
}
@media (max-width: 1530px) {
  .title-box_card {
    max-width: 180px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  .title-box_card_popover {
    display: block;
  }
}
@media (max-width: 1199px) {
  .title-box_card {
    max-width: 100px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  .icon {
    display: none;
  }
  .box__status{
    display: none;
  }
  .count{
    margin-right: 20px;
  }
}
@media (max-width: 992px) {
  .box-2 {
    margin-top: 10px;
  }
  .div-chart {
    margin-top: -16px;
  }
}
@media (max-width: 768px) {
  .calendar {
    margin-top: 10px;
  }
}
@media (max-width: 547px) {
  .card-panel {
    margin-bottom: 15px;
  }
}
</style>
